module.exports = __webpack_public_path__ + "img/device_cover_sag.3d8e1883.png";